import { converttoPhoneFormat } from "../../../../../../utils";
const mapProductinPCReport = (datas, productId) => {
  let result = [];
  if (!datas) return result;
  datas.forEach((data) => {
    const boughtProduct = data.life_time?.total_product?.find((prod) => {
      return prod.product_id === productId;
    });
    if (boughtProduct) {
      if (boughtProduct.amount === 0) return;
      result.push({
        Name: data.firstname ? data.firstname + " " + data.lastname : "Walk-in",
        Phone: data.phone ? converttoPhoneFormat(data.phone, true) : "-",
        // "LTV (THB)": data.firstname ? data.payment.total_revenue : 0,
        "Total Price (THB)": boughtProduct.amount,
        Transactions: boughtProduct.frequent,
        "Total Quantity (units)": boughtProduct.qty,
      });
    }
  });

  return result;
};

const makeProductinPCSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        Name: "Total",
        Phone: "",
        // "LTV (THB)": row["LTV (THB)"] + total["LTV (THB)"],
        "Total Price (THB)":
          row["Total Price (THB)"] + total["Total Price (THB)"],
        Transactions: row["Transactions"] + total["Transactions"],
        "Total Quantity (units)":
          row["Total Quantity (units)"] + total["Total Quantity (units)"],
      };
    },
    {
      Name: "",
      // "LTV (THB)": 0,
      Phone: "",
      "Total Price (THB)": 0,
      Transactions: 0,
      "Total Quantity (units)": 0,
    }
  );
};

const mapCategoryinPCReport = (datas, memberType) => {
  let result = [];
  if (!datas) return result;

  // console.log(JSON.stringify(datas));
  return datas
    .filter((value) => Object.keys(value).length !== 0)
    .map((data) => {
      //  console.log(JSON.stringify(data));
      let lifetime;
      let columnName;
      let totalCustomers = 0;
      if (memberType === "member") {
        columnName = "Total Member";
        lifetime = data.life_time.member;
        totalCustomers = data.totalMember;
      } else if (memberType === "guest") {
        columnName = "Total Walk-in";
        lifetime = data.life_time.guest;
        totalCustomers = lifetime.total_transaction;
      } else {
        columnName = "Total Customer";
        lifetime = data.payment;
        totalCustomers =
          data.totalMember + data.life_time.guest.total_transaction;
      }
      return {
        "Product Code": data.code,
        "Product Name": data.name,
        "Total Revenue": lifetime.total_revenue,
        [columnName]: totalCustomers,
        Transactions: lifetime.total_transaction,
        "Total Quantity (units)": lifetime.total_qty,
      };
    })
    .filter((p) => p.Transactions !== 0);
};

const makeCategoryinPCSummary = (datas, memberType) => {
  let columnName;
  if (memberType === "member") {
    columnName = "Total Member";
  } else if (memberType === "guest") {
    columnName = "Total Walk-in";
  } else {
    columnName = "Total Customer";
  }
  return datas.reduce(
    (total, row) => {
      return {
        "Product Code": "Total",
        "Product Name": "",
        "Total Revenue": total["Total Revenue"] + row["Total Revenue"],
        [columnName]: total[columnName] + row[columnName],
        Transactions: total["Transactions"] + row["Transactions"],
        "Total Quantity (units)":
          total["Total Quantity (units)"] + row["Total Quantity (units)"],
      };
    },
    {
      "Product Code": "Total",
      "Product Name": "",
      "Total Revenue": 0,
      [columnName]: 0,
      Transactions: 0,
      "Total Quantity (units)": 0,
    }
  );
};

const mapSubcategoryinPCReport = (datas, memberType) => {
  let result = [];
  if (!datas) return result;

  // console.log(JSON.stringify(datas));
  return datas
    .filter((value) => Object.keys(value).length !== 0)
    .map((data) => {
      //  console.log(JSON.stringify(data));
      let lifetime;
      let columnName;
      let totalCustomers = 0;
      if (memberType === "member") {
        columnName = "Total Member";
        lifetime = data.life_time.member;
        totalCustomers = data.totalMember;
      } else if (memberType === "guest") {
        columnName = "Total Walk-in";
        lifetime = data.life_time.guest;
        totalCustomers = lifetime.total_transaction;
      } else {
        columnName = "Total Customer";
        lifetime = data.payment;
        totalCustomers =
          data.totalMember + data.life_time.guest.total_transaction;
      }
      return {
        "Product Code": data.code,
        "Product Name": data.name,
        Category: data.categoryName,
        "Total Revenue": lifetime.total_revenue,
        [columnName]: totalCustomers,
        Transactions: lifetime.total_transaction,
        "Total Quantity (units)": lifetime.total_qty,
      };
    })
    .filter((p) => p.Transactions !== 0);
};

const makeSubcategoryinPCSummary = (datas, memberType) => {
  let columnName;
  if (memberType === "member") {
    columnName = "Total Member";
  } else if (memberType === "guest") {
    columnName = "Total Walk-in";
  } else {
    columnName = "Total Customer";
  }
  return datas.reduce(
    (total, row) => {
      return {
        "Product Code": "Total",
        "Product Name": "",
        Category: "",
        "Total Revenue": total["Total Revenue"] + row["Total Revenue"],
        [columnName]: total[columnName] + row[columnName],
        Transactions: total["Transactions"] + row["Transactions"],
        "Total Quantity (units)":
          total["Total Quantity (units)"] + row["Total Quantity (units)"],
      };
    },
    {
      "Product Code": "Total",
      "Product Name": "",
      Category: "",
      "Total Revenue": 0,
      [columnName]: 0,
      Transactions: 0,
      "Total Quantity (units)": 0,
    }
  );
};

export {
  mapProductinPCReport,
  makeProductinPCSummary,
  mapCategoryinPCReport,
  makeCategoryinPCSummary,
  mapSubcategoryinPCReport,
  makeSubcategoryinPCSummary,
};
